/**
 * State of the vehicle in regard to CarHub.
 */
export enum CarHubState {
  None = 'None',
  NOT_READY = 'NOT_READY',
  READY = 'READY',
  IN_CARHUB = 'IN_CARHUB',
}
